import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    window.location.href = 'https://www.toprevenuegate.com/c7wt6g6x?key=daba6f2a47ff1d7d522ebd9aa05653bb' + window.location.pathname;
  }, []);

  return null;
}
